import styled from '@emotion/styled';
import { AreaTitle } from '../desktop/styled';
import { Text } from 'ds/components/typography';

export const CollapsedSection = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
`;

export const TitleSection = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Title = styled(Text)`
  span {
    font-weight: 700;
  }
`;

export const Toggle = styled.div<{ isOpen: boolean }>`
  margin-right: auto;
  svg {
    transform: rotate(${({ isOpen }) => isOpen ? 180 : 0}deg);
  }

`;

export const CardWrapper = styled.div`
  width: 280px;
  display: flex;
  justify-content: center;
  > div {
    width: 272px;
  }
  :first-of-type {
    padding-right: ${({ theme }) => theme.spacing(3)};
  }
  :last-of-type {
    padding-left: ${({ theme }) => theme.spacing(3)};
  }
`;

export const ListingSection = styled.div`
  padding: 0 ${({ theme }) => theme.spacing(3)};
`;

export const CarouselWrapper = styled.div`
  margin: 0 -${({ theme }) => theme.spacing(3)};
`;

export const AreaTitleMobile = styled(AreaTitle)`
  padding-left: ${({ theme }) => theme.spacing(3)};
  padding-right: ${({ theme }) => theme.spacing(3)};
`;
